var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOverviewProjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 48,
    height: 48,
    rx: 8,
    fill: "#00CC99",
    fillOpacity: 0.15
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_784_4835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.6072 19.8086H22.5358C22.3432 19.8086 22.1585 19.8851 22.0223 20.0213C21.8861 20.1575 21.8096 20.3422 21.8096 20.5348V36.5109C21.8096 36.7035 21.8861 36.8882 22.0223 37.0244C22.1585 37.1606 22.3432 37.2371 22.5358 37.2371H35.6072C35.7997 37.2371 35.9845 37.1606 36.1206 37.0244C36.2568 36.8882 36.3333 36.7035 36.3333 36.5109V20.5348C36.3333 20.3422 36.2568 20.1575 36.1206 20.0213C35.9845 19.8851 35.7997 19.8086 35.6072 19.8086ZM33.4286 31.4276H24.7143V29.9752H33.4286V31.4276ZM33.4286 28.5229H24.7143V27.0705H33.4286V28.5229ZM33.4286 25.6181H24.7143V24.1657H33.4286V25.6181Z",
    fill: "#00CC99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4524 29.9761V15.4524H30.5238V14.7262C30.5238 14.5336 30.4473 14.3489 30.3111 14.2127C30.1749 14.0765 29.9902 14 29.7976 14H16.7262C16.5336 14 16.3489 14.0765 16.2127 14.2127C16.0765 14.3489 16 14.5336 16 14.7262V30.7023C16 30.8949 16.0765 31.0796 16.2127 31.2158C16.3489 31.352 16.5336 31.4285 16.7262 31.4285H17.4524V29.9761Z",
    fill: "#00CC99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3569 32.8804V18.3567H33.4283V17.6305C33.4283 17.4379 33.3518 17.2532 33.2156 17.117C33.0794 16.9808 32.8947 16.9043 32.7021 16.9043H19.6307C19.4381 16.9043 19.2534 16.9808 19.1172 17.117C18.9811 17.2532 18.9045 17.4379 18.9045 17.6305V33.6066C18.9045 33.7992 18.9811 33.9839 19.1172 34.1201C19.2534 34.2563 19.4381 34.3328 19.6307 34.3328H20.3569V32.8804Z",
    fill: "#00CC99"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_784_4835"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(14 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOverviewProjects);
export default __webpack_public_path__ + "static/media/ICON_OVERVIEW_PROJECTS.507b69f6d06b707984816a55fed35b12.svg";
export { ForwardRef as ReactComponent };